import Entity from "./Entity";

export default class Publisher extends Entity {
    constructor(data) {
        super(data);
    }

    get id() {
        return this.get("id");
    }

    getId() {
        return this.get("id");
    }

    getContactGroupByPOIType() {
        const contactGroups = this.get("contactGroupByPOIType");
        const result = [];

        if (contactGroups && contactGroups.emergency) {
            result.push(contactGroups.emergency);
        }

        if (contactGroups && contactGroups.terrain_report) {
            result.push(contactGroups.terrain_report);
        }

        return result;
    }

    getContactGroupEmergency() {
        return (this.get("contactGroupByPOIType") || {}).emergency;
    }

    getContactGroupTerrainReport() {
        return (this.get("contactGroupByPOIType") || {}).terrain_report;
    }

    getBundleIds() {
        return this.get("bundleIds");
    }

    getUsersIds() {
        return this.get("users");
    }

    removeUserId(uid) {
        const users = this.get("users");
        const index = users.indexOf(uid);
        if (index !== -1) {
            users.splice(index, 1);
        }
        this.set("users", users);
    }

    getName() {
        return this.get("name");
    }

    getGeneralStatistics() {
        return this.get("generalStatistics");
    }
}